export type DailyRecapBriefingChoice =
  | "daily"
  | "pause_7_days"
  | "pause_30_days"
  | "disabled";

export interface DailyRecapBriefingPreference {
  mode: "daily" | "paused" | "disabled";
  choice: DailyRecapBriefingChoice;
  pause_days: 7 | 30 | null;
  paused_until: string | null;
  first_presented_at: string | null;
  can_manage: boolean;
}

export interface DailyRecapBriefingNotification {
  id: number;
  company_id: number;
  warehouse_id: number;
  warehouse_name: string | null;
  type: "daily_recap";
  title: string;
  message: string;
  data: Record<string, unknown>;
  priority: string;
  created_at: string | null;
}

export interface DailyRecapBriefing {
  claim_token: string;
  recap_date: string;
  timezone: string;
  notifications: DailyRecapBriefingNotification[];
}

export const DAILY_RECAP_BRIEFING_OPTIONS: Array<{
  value: DailyRecapBriefingChoice;
  label: string;
}> = [
  { value: "daily", label: "Chaque jour" },
  { value: "pause_7_days", label: "Suspendre pendant 7 jours" },
  { value: "pause_30_days", label: "Suspendre pendant 30 jours" },
  { value: "disabled", label: "Désactiver jusqu’à réactivation" },
];
